function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, inputError, inputValue) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const proxyAttrs = {};;
    ['closeable', 'open', 'grow-to-content'].forEach(attr => proxyAttrs[attr] = $attr(attr));;
    return {
      value: (h("mp-modal", {
        "attrs": __vjadeStringifyAttrsIfObj(proxyAttrs),
        "on": {
          change: $helpers.modalChanged
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-confirm-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-confirm-body': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-body-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`banner-text`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-banner", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `info`,
                    type: `embedded`,
                    'body-text': $attr(`banner-text`),
                  }),
                  "class": {
                    'mp-confirm-info-banner': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(($attr(`title`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-title': true
                  },
                }, [__vjadeSafeCode($attr(`title`))]));;
                return __jade_nodes
              }).call(this)) : undefined);
              const description = $attr(`description`);
              __jade_nodes = __jade_nodes.concat((description) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((($attr(`description-allow-newline`))) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-confirm-description-newline': true
                    },
                  }, [__vjadeSafeCode($helpers.formatText(description, {
                    className: `confirm-description-newline`
                  }))]));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-confirm-description': true
                    },
                  }, [__vjadeSafeCode(description)]));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(($attr(`show-input`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    elref: `confirmInput`,
                    'error-message': inputError,
                    'validation-status': inputError ? `invalid` : ``,
                  }),
                  "hook": {
                    insert: $helpers.onInputInserted
                  },
                  "on": {
                    input: $helpers.changeInputValue,
                    keyup: $helpers.commitInputValue,
                    change: ev => ev.stopPropagation(),
                  },
                  "props": {
                    value: inputValue
                  },
                  "class": {
                    'mp-confirm-input': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("slot"));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-confirm-buttons': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!$attr(`hide-cancel-button`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`theme`) !== `info`) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `tertiary`,
                    elref: `mpConfirmCancelButton`
                  }),
                  "on": {
                    click: $helpers.cancel
                  },
                  "class": {
                    'mp-confirm-button-cancel': true,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($attr(`cancel-button-label`) || `Cancel`);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                disabled: $helpers.isConfirmButtonDisabled(),
                theme: `primary`,
                type: $attr(`theme`) === `delete` ? $helpers.ButtonType.Destructive : $helpers.ButtonType.Info,
              }),
              "on": {
                click: $helpers.confirm
              },
              "class": {
                'mp-confirm-button-accept': true,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`confirm-button-label`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($attr(`confirm-button-label`));;
                return __jade_nodes
              }).call(this)) : ($attr(`theme`) === `delete`) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Delete");;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Okay");;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "inputError" in locals ? locals.inputError : typeof inputError !== "undefined" ? inputError : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;